module.exports = "<section class=\"content\"><div class=\"content-wrap col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-2\"><span class=\"line\"></span><p [innerHTML]=\"contentString | safeHtml\"></p></div></section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/content/content.component.html
// module id = ../../../../../src/app/content/content.component.html
// module chunks = main